import {
  getEndPoint,
  getNodeEntries,
  GetNodeEntriesOptions,
  getNodeString,
  insertNodes,
  isText,
  select,
  TText,
} from '@udecode/plate';
import twitterText from 'twitter-text';

import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { withoutLosingSelection } from '~/editor/helpers/withoutLosingSelection';
import { TwitterHashtagInputElement } from '../nodes';

/**
 * Find all text in the editor that are valid twitter
 * hashtags and convert them to twitter hashtag elements
 */
export const findAndCreateTwitterHashtags = (
  editor: BufferEditor,
  options?: Pick<GetNodeEntriesOptions, 'at' | 'reverse'>
): void => {
  // Get all leaf text nodes
  const leafEntriesGenerator = getNodeEntries<TText>(editor, {
    at: [],
    ...options,
    reverse: true,
    mode: 'all',
    match: (n) => isText(n),
  });
  const leafEntries = Array.from(leafEntriesGenerator);

  // Iterate over the leaf text nodes
  leafEntries.forEach(([node, nodePath]) => {
    const nodeText = getNodeString(node);

    // Search for hashtags and wrap them with twitter hashtag elements
    withoutLosingSelection(editor, () => {
      twitterText
        .extractHashtagsWithIndices(nodeText)
        .reverse()
        .forEach((hashtag) => {
          const range = {
            anchor: { path: nodePath, offset: hashtag.indices[0] },
            focus: { path: nodePath, offset: hashtag.indices[1] },
          };
          insertNodes(editor, TwitterHashtagInputElement.new(hashtag.hashtag), {
            at: range,
          });
        });
    });
  });

  // Move selection to end of editor content
  const editorEndPoint = getEndPoint(editor, []);
  select(editor, {
    anchor: editorEndPoint,
    focus: editorEndPoint,
  });
};
